import { render, staticRenderFns } from "./VirHomePart4.vue?vue&type=template&id=7825575f&scoped=true&"
import script from "./VirHomePart4.vue?vue&type=script&lang=js&"
export * from "./VirHomePart4.vue?vue&type=script&lang=js&"
import style0 from "./VirHomePart4.vue?vue&type=style&index=0&id=7825575f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7825575f",
  null
  
)

export default component.exports